import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import config from "../config";
import { logger } from "../utils/utils";
import queryString from "query-string";
import ImagenesLista from "../imageUploadV3/ImagenesLista";
import { HexColorPicker } from "react-colorful";
import Loader from "../utils/Loader";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";

const { Text } = Inputs;

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];

function EditProfesional({ history, match }) {
  const dispatch = useDispatch();

  const profesionalId = match.params.id;

  const modelEditProfesional = useSelector((state) => state.editProfesional);
  const modelProfesionalById = useSelector((state) => state.profesionalById);

  const [nombre, setNombre] = useState(null);
  const [profesion, setProfesion] = useState(null);
  const [estado, setEstado] = useState("ACTIVO");
  const [localId, setLocalId] = useState(null);

  const [token] = useState(() => localStorage.getItem("token"));
  const [imagenes, setImagenes] = useState();
  const [imagenesListaLoading, setImagenesListaLoading] = useState(false);

  const [color, setColor] = useState("#aabbcc");
  const [mostrarColorPicker, setMostrarColorPicker] = useState(false);

  const [colorActual, setColorActual] = useState(null);

  const modelEliminacionImgProfesional = useSelector((state) => {
    return state.eliminacionImgProfesional;
  });

  // mount
  useEffect(() => {
    dispatch(controller.profesionalByIdThunk(match.params.id));
  }, []);

  useEffect(() => {
    // TODO usar "selectors" para data y error

    const data = modelEliminacionImgProfesional?.data?.data?.data;
    const error = modelEliminacionImgProfesional?.error;
    const errorMessage =
      modelEliminacionImgProfesional?.error?.response?.data?.mensaje;

    if (error) {
      if (errorMessage) {
        alert(errorMessage);
      }
      setImagenesListaLoading(false);
      dispatch(controller.duckEliminarImgServicio.actions.clear());
    }

    if (data) {
      dispatch(controller.profesionalByIdThunk(match.params.id));
    }
  }, [modelEliminacionImgProfesional, dispatch]);

  useEffect(() => {
    const data = modelProfesionalById?.data?.data?.data;
    const error = modelProfesionalById?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckProfesionalById.actions.clear());
    }
    if (data) {
      setNombre(data.nombre);
      setProfesion(data.profesion);
      setEstado(data.estado);
      setLocalId(data.localId);
      setImagenes(data.imagenes);
      setImagenesListaLoading(false);
      data.color && setColorActual(data.color);
      dispatch(controller.duckProfesionalById.actions.clear());
    }
  }, [modelProfesionalById]);

  useEffect(() => {
    const data = modelEditProfesional?.data?.data;
    const error = modelEditProfesional?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckEditProfesional.actions.clear());
    }
    if (data) {
      history.push(`/profesionales/${localId}`);
      dispatch(controller.duckEditProfesional.actions.clear());
    }
  }, [modelEditProfesional]);

  function submit() {
    if (!nombre || !estado || !localId) {
      alert("Por favor complete todos los campos");
      return;
    }
    let data = {
      _id: match.params.id,
      nombre,
      estado,
      localId,
      profesion,
      color: mostrarColorPicker ? color : colorActual,
    };
    dispatch(controller.editProfesionalThunk(data));
  }

  const navigateToSubirImagenes = () => {
    logger.debug("navigateToSubirImagenes");

    const baseUrl = config.api.baseUrl;
    const key = config.api.key;

    const concepto = "profesional";
    const conceptoId = profesionalId;

    logger.debug({ concepto });
    logger.debug({ config });
    logger.debug({
      imgRestrictionsByConcepto: config.imgRestrictionsByConcepto[concepto],
    });

    const uploadConfigVariant = "upload";
    const cropConfigVariant = "crop";

    const uploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=true&configVariant=${uploadConfigVariant}`;
    const uploadHeaders = {
      "x-access-token": key,
    };

    const cropUploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=false&configVariant=${cropConfigVariant}`;
    const cropConfig =
      config.imgRestrictionsByConcepto[concepto][cropConfigVariant];

    const nextStepUrl = `/cortarImagenes`;
    const lastStepUrl = `/editProfesional/${profesionalId}`;

    const params = queryString.stringify({
      conceptoId,
      concepto,
      uploadUrl,
      rawUploadHeaders: JSON.stringify(uploadHeaders),
      nextStepUrl,
      pageTitle: "Subida de imágenes",
      pageSubtitle: "Paso 1 : Subida",
      nextButtonText: "Siguiente",
      cropConfig: JSON.stringify(cropConfig),
      cropUploadUrl,
      saveInConceptUrl: `${baseUrl}/agregarImagenAProfesional`,
      lastStepUrl,
      ...config.imgRestrictionsByConcepto[concepto][uploadConfigVariant],
    });

    logger.debug("EditServicioHijo.paramsBeforeNavigate");
    logger.debug(params);

    history.push(`/subirImagenes?${params}`);
  };

  const doEliminarImagen = (imagenID) => {
    setImagenesListaLoading(true);

    let data = {
      imagenID,
      profesionalId: profesionalId,
      token,
    };
    dispatch(controller.eliminarImgProfesionalThunk(data));
  };

  return (
    <Content
      title="Editar profesional"
      browserTitle="Editar profesional"
      show={false}
    >
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Editar profesional"
            footer={
              <>
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.push(`/profesionales/${localId}`);
                  }}
                />

                <Button
                  type="primary"
                  text={
                    <Loader
                      loaderColor="#ffffff"
                      isLoading={modelEditProfesional.loading}
                    >
                      Guardar cambios
                    </Loader>
                  }
                  pullRight={true}
                  disabled={modelEditProfesional.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Profesión"
              value={profesion}
              onChange={(evt) => setProfesion(evt.target.value)}
            />
            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={estadoOptions()}
            />

            <label>Color para calendario</label>
            <br />

            {colorActual ? (
              <>
                Color actual:{" "}
                <div
                  style={{
                    width: 15,
                    height: 15,
                    backgroundColor: colorActual,
                    display: "inline-block",
                  }}
                ></div>
              </>
            ) : (
              "Sin color definido"
            )}

            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={() => setMostrarColorPicker(!mostrarColorPicker)}
                  checked={mostrarColorPicker}
                />{" "}
                Definir nuevo color
              </label>
            </div>

            {mostrarColorPicker && (
              <HexColorPicker color={color} onChange={setColor} />
            )}
          </Box>
        </Col>
      </Row>
      {/* <Row>
        <Col xs="12" md="6" mdOffset="3">
          <div style={{ display: "inline-block" }}>
            <h4 style={{ display: "inline-block" }}>Imágenes subidas</h4>
          </div>

          <ImagenesLista
            imagenes={imagenes}
            doEliminarImagen={doEliminarImagen}
            loading={imagenesListaLoading}
            // navigateToSubirThumbnail={navigateToSubirThumbnail}
          />
        </Col>
      </Row> */}
   <Col md="4" mdOffset="4">
      <Box
        title="Editar Imagen"
        footer={
          <Button
            type="primary"
            text="Subir imágenes"
            pullRight={true}
            onClick={navigateToSubirImagenes}
          />
        }
      >
        <Col xs="12" md="12">
          <div style={{ display: "inline-block" }}>
            <h4 style={{ display: "inline-block" }}>Imágenes subidas</h4>
          </div>

          <ImagenesLista
            imagenes={imagenes}
            doEliminarImagen={doEliminarImagen}
            loading={imagenesListaLoading}
            // navigateToSubirThumbnail={navigateToSubirThumbnail}
          />
        </Col>
      </Box>
      </Col>
    </Content>
  );
}

export default EditProfesional;
